(ns renolit-roofing-service.layout.form.form-item.text-area
  (:require [goog.object :as g]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util :as util]))

(defn- on-change-event-handler
  [{:keys [schema] :or {schema [:string]} :as opts}]
  (fn [e]
    (let [event-value (g/getValueByKeys e "target" "value")
          new-value (when (seq event-value)
                      (m/decode schema event-value mt/string-transformer))]
      (form.form-item/on-change-event-handler opts :on-change new-value))))

(defn- on-blur-event-handler
  [{:keys [on-blur]}]
  (fn [_]
    (util/execute-callback on-blur)))

(defn- on-focus-event-handler
  [{:keys [on-focus]}]
  (fn [_]
    (util/execute-callback on-focus)))

(defn- on-click-event-handler
  [{:keys [on-click]}]
  (fn [_]
    (util/execute-callback on-click)))

(defn- main
  [{:keys [context path] :as _opts}]
  (let [component-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])]
    (fn [{:keys [state path disabled? label
                 label-transl-kw placeholder-transl-kw
                 description-transl-kw
                 input-opts css-class-prefix
                 on-blur on-focus on-click mandatory? read-only?]
          :as opts}]
      [:div.form-item
       {:class [(when disabled? "form-item--disabled")
                (when css-class-prefix css-class-prefix)
                (when (seq @form-errors) "form-item--error")]}
       (when (or label-transl-kw label)
         [:label.form-item__label
          (cond-> {:for component-id}
            css-class-prefix
            (assoc :class (str css-class-prefix "__label"))

            (seq @form-errors)
            (assoc :title (form.error/form-error->msg (first @form-errors))))
          (or (t [label-transl-kw]) label)
          (when mandatory?
            [:span.form-item__mandatory "*"])])
       (when description-transl-kw
         [:span.form-item__description
          (t [description-transl-kw])])
       [:textarea.form-item__text-area.form-item__input
        (cond-> {:id component-id
                 :disabled (boolean disabled?)
                 :read-only read-only?
                 :value (or (get-in @state path) "")
                 :on-change (on-change-event-handler opts)
                 :class []}
          placeholder-transl-kw
          (assoc :placeholder (t [placeholder-transl-kw]))

          (seq on-blur)
          (assoc :on-blur (on-blur-event-handler opts))

          (seq on-focus)
          (assoc :on-focus (on-focus-event-handler opts))

          (seq on-click)
          (assoc :on-click (on-click-event-handler opts))

          css-class-prefix
          (update :class conj (str css-class-prefix "__text-area"))

          input-opts
          (merge input-opts))]])))

(defmethod form.form-item/form-item-component :text-area
  [opts]
  [main opts])